export default __webpack_public_path__ + "static/media/Spring21_01.8dc1526f.png";